import axios from 'axios'
import store from '@/store'
import qs from 'qs'
import { lang } from '@/utils/lang'
// import Cookies from 'js-cookie'

const _lang = lang === 'zh' ? 'cn' : 'en'
const commonParams = {
  lan: _lang
}

export const config = {
  // timeout: 5000,
  baseURL: '/api',
  params: commonParams,
  data: commonParams,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    return qs.stringify(data)
  }]
}

// 本地调试，写死用户Token
if (process.env.NODE_ENV === 'development') {
  // config.headers['token'] = '7c78c892-890a-4262-9d5a-e01968eba538'
} else {
  // let token = Cookies.get('token')
  // config.headers['token'] = token
  // store.commit('SET_TOKEN', token)
}

const service = axios.create(config)

service.interceptors.response.use(response => {
  let res = response.data
  if (res.code === 1 || res.code === '1') {
    return res
  } else {
    return Promise.reject(res)
  }
}, error => {
  if (error && error.response) {
    let code = error.response.data.code || error.response.status
    let msg = error.response.data.msg || error.response.statusText
    store.commit('SET_API_STATUS', {code, msg})
  }
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js